import { ChangeEvent, useEffect, useRef, useState } from "react";
import Client from "../../../../model/Client";
import CenteredModal from "../../CenteredModal";
import TextField from "@mui/material/TextField";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";

import { useTheme } from "styled-components";
import { Modal } from "react-bootstrap";
import Button from "@mui/material/Button";
import { getClients } from "../../../../store/actions/clientActions";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import { clientListSelector, loadingClientQuerySelector } from "../../../../store/selectors/clientSelector";
import LoadingSpinner from "../../../../assets/components/LoadingSpinner";


interface ClientSearchModalProps {
    handleModalClose: () => void;
    handleClientSelection: (client: Client) => void;
}

const ClientSearchDialog: React.FC<ClientSearchModalProps> = ({handleModalClose, handleClientSelection}) => {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    var [searchText, setSearchText] = useState<string>("")
    var [selection, setSelection] = useState<Client | null>(null);
    const clickTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const handleRowClick = (client: Client) => {
        if (clickTimeoutRef.current) {
            clearTimeout(clickTimeoutRef.current);
            clickTimeoutRef.current = null;
            handleClientSelection(client);
        } else {
            setSelection(selection === client ? null : client);
            clickTimeoutRef.current = setTimeout(() => {
                clickTimeoutRef.current = null;
            }, 250); // 250ms for double click detection
        }
    };
    const clients = useAppSelector(clientListSelector)
    const loading = useAppSelector(loadingClientQuerySelector)

    useEffect(() => {
        dispatch(getClients({              
            QueryString: searchText                
        }));
    }, [dispatch]);
    
    useEffect(() => {
        dispatch(getClients({                    
            QueryString: searchText                
        }));
    }, [dispatch, searchText])

    return <CenteredModal
            title="Find Client"
            show={true}
            onHide={() => handleModalClose()}
            vCenter={true}
            style={{ maxHeight: "80vh", overflowY: "hidden" }}>
        
        <TextField placeholder="Search" value={searchText} onChange={(e: ChangeEvent<HTMLInputElement>) => setSearchText(e.target.value)} sx={{ margin: 1}}/>
        <div style={{ maxHeight: "50vh", overflowY: "auto", margin: 1 }}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell>Code</TableCell>
                        <TableCell>Name</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {!loading && clients 
                        .filter(x => x.code.toLowerCase().includes(searchText.toLowerCase()) || x.name.toLowerCase().includes(searchText.toLowerCase())).map(x => (
                            <TableRow 
                                hover 
                                key={x.code} 
                                onClick={() => handleRowClick(x)} 
                                sx={{ 
                                    background: selection === x ? theme.palette.primary.main : "", 
                                    "td" : {
                                        color: (selection === x ? theme.palette.primary.contrastText  : "") + "!important"
                                    }, 
                                    ":hover": {
                                        background: (selection === x ? theme.palette.primary.main : "rgba(0,0,0,0.04)") + "!important", 
                                    }
                                }}>
                                <TableCell>{x.code}</TableCell>
                                <TableCell>{x.name}</TableCell>
                            </TableRow>
                        )
                    )}

                    {loading &&
                        <LoadingSpinner style={{ width: "3rem"}} />
                    }
                </TableBody>
            </Table>
        </div>
        <Modal.Footer>               
            <Button                
                disabled={selection === null}   
                onClick={() => handleClientSelection(selection!)}               
            >
                Submit
            </Button>
            <Button                                
                onClick={(_) => handleModalClose()}
            >
                Close
            </Button>                 
        </Modal.Footer>
    </CenteredModal>    
};



export default ClientSearchDialog;
